// Capability-tier derivation for the chat-panel chip row.
//
// Tier is a presentation summary over the live `/api/v1/health` capability
// snapshot. There is no provider-side or session-meta source of truth — the
// chip reflects how rich the workspace's KB augmentations are, full stop.
//
// Rules:
//   - basic (1)    → no KB config, or KB alone with no augmentations
//   - standard (2) → KB + 1 or 2 of {domain agents, sub-agents, skills present}
//   - rich (3)    → KB + all three augmentations
//
// Inputs are read from the slice's nullable `CapabilitySnapshot`; null
// (pre-first-poll) is treated as "nothing known" and yields tier 1.

import type { CapabilitySnapshot } from '../../state/capabilities.js';

export function computeCapabilityTier(snapshot: CapabilitySnapshot | null): 1 | 2 | 3 {
  if (snapshot === null || !snapshot.hasKbConfig) {
    return 1;
  }
  const augmentations =
    (snapshot.hasDomainAgents ? 1 : 0) +
    (snapshot.hasSubAgents ? 1 : 0) +
    (snapshot.activeSkillCount > 0 ? 1 : 0);
  if (augmentations === 0) return 1;
  if (augmentations === 3) return 3;
  return 2;
}
